import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfService } from '../../../service/shelf/shelf.service';
import { ShelfcaseService } from '../../../service/shelfcase/shelfcase.service';
import { CaseService } from '../../../service/case/case.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9244',
  templateUrl: 'wa9244.component.html',
  styleUrls: ['wa9244.component.scss']
})
export class Wa9244Component implements OnInit {
  public componentTitle = 'WA9244:格納什器ケースマスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public cases: any;
  public shelves: any;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public shelfcaseTx: FormControl;
  public shelfCd: FormControl;
  public caseCd: FormControl;
  public layerNr: FormControl;
  public orderNr: FormControl;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';


  private shelfcaseTxCls = '';
  private shelfCdCls = '';
  private caseCdCls = '';
  private layerNrCls = '';
  private orderNrCls = '';

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private shelfcaseService: ShelfcaseService,
    private shelfService: ShelfService,
    private caseService: CaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    this.shelfcaseTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.shelfTx.maxLength)
    ]);
    this.shelfCd = new FormControl('', [
      Validators.required
    ]);
    this.caseCd = new FormControl('', [
      Validators.required
    ]);
    this.layerNr = new FormControl('', [
      Validators.required,
      Validators.max(validation.layerNr.maxNr),
      Validators.min(validation.layerNr.minNr)
    ]);
    this.orderNr = new FormControl('', [
      Validators.required,
      Validators.max(validation.orderNr.maxNr),
      Validators.min(validation.orderNr.minNr)
    ]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
     // this.shelfCdElement.nativeElement.focus();
      this.onView();
    }, 500);
  }

  onView() {
    this.shelfService
      .get()
      .then(__outputJson => {
        this.shelves = __outputJson.shelves;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.caseService
      .get()
      .then(__outputJson => {
        this.cases = __outputJson.cases;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled) {
      return;
    }

    let errors = false;
    if (this.shelfcaseTx.errors !== null) {
      this.shelfcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfCd.errors !== null) {
      this.shelfCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseCd.errors !== null) {
      this.caseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.layerNr.errors !== null) {
      this.layerNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.orderNr.errors !== null) {
      this.orderNr.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (errors) {
      return;
    }


    const shelfcaseTx = this.shelfcaseTx.value.trim();
    const shelfCd = this.shelfCd.value;
    const caseCd = this.caseCd.value;
    const layerNr = this.layerNr.value;
    const orderNr = this.orderNr.value;

    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shelfcaseService
      .post(shelfcaseTx, shelfCd, caseCd, layerNr, orderNr, 'wa9244')
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
      this.shelfcaseTx.setValue('');
      this.shelfCd.setValue('');
      this.caseCd.setValue('');
      this.layerNr.setValue('1');
      this.orderNr.setValue('1');
      this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow) {
      return;
    }

    this.shelfcaseTxCls = this.shelfcaseTx.value === '' ? '' : (this.shelfcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.shelfCdCls = this.shelfCd.value === '' ? '' : (this.shelfCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.caseCdCls = this.caseCd.value === '' ? '' : (this.caseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.layerNrCls = this.layerNr.value == null ? '' : (this.layerNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.orderNrCls = this.orderNr.value == null ? '' : (this.orderNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
      ((this.shelfcaseTxCls === this.STRINGS_ACTIVE)
      && (this.shelfCdCls === this.STRINGS_ACTIVE)
      && (this.caseCdCls === this.STRINGS_ACTIVE)
      && (this.layerNrCls === this.STRINGS_ACTIVE) 
      && (this.orderNrCls === this.STRINGS_ACTIVE));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9244/wa9244.component.ts